
import TableList from "@components/templates/tablelist";
import compBatchImport from "./import.vue";
import compIndex from "./update.vue";
import mixin from "./mixin";
import {
    HttpGetForcastList,
    HttpDeleteForecast
} from "@/service/purchase/purchase.js"
import { mapState, mapGetters } from "vuex";
export default {
    mixins: [TableList, mixin],
    components: {
        compBatchImport,
        compIndex
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                    'EQ_status': null,
                    queryEndDate: 0
                }
            },
            Searchs: {
                show: true,
                labelWidth: 100,
            },
            datename: '',
            datetime: '',
            Plugins: { show: true },
            initData: '',
        };
    },
    methods: {
        ajaxRequest: HttpGetForcastList,
        interceptRequest(params) {
            return this.handleParams(params);
        },
        handleParams(params) {
            let searchData = params.search;
            // 今天
            let nowDate = this.handleDateFormat(new Date(), 'yyyy-mm-dd');
            // 昨天
            let lastDate = this.handleDateFormat((new Date() - 24 * 60 * 60 * 1000), 'yyyy-mm-dd');
            console.log(searchData.queryEndDate);
            // 所有
            if (searchData.queryEndDate == 0) {
                delete searchData.LE_endDate;
                delete searchData.GE_endDate;
                // this.formData.search.queryEndDate = 0;
                this.$set(this.formData.search, 'queryEndDate', 0);
            }
            // 有效
            else if (searchData.queryEndDate == 1) {
                searchData.GE_endDate = nowDate;
                delete searchData.LE_endDate;
                // this.formData.search.queryEndDate = 1;
                this.$set(this.formData.search, 'queryEndDate', 1);
            }
            // 失效
            else if (searchData.queryEndDate == 2) {
                searchData.LE_endDate = lastDate;
                delete searchData.GE_endDate;
                // this.formData.search.queryEndDate = 2;
                this.$set(this.formData.search, 'queryEndDate', 2);
            }
            // 重置
            else {
                delete searchData.LE_endDate;
                delete searchData.GE_endDate;
                // this.formData.search.queryEndDate = 0;
                this.$set(this.formData.search, 'queryEndDate', 0);
            }
            let { queryEndDate, ...finalSearchData } = {
                ...searchData
            };
            return {
                ...params,
                search: {
                    ...finalSearchData
                }
            }
        },
        toolsRender() { //自定义工具行
            return (
                <div class="back-fff clearfix padding-10 margin-bottom-10">
                    <div class="pull-left">
                        <Button type="success" class="margin-right-15" nativeOnClick={this.handleOperates.bind(this, '', 'batchImport')}>批量导入</Button>
                        <Button type="default" class="margin-right-15" nativeOnClick={this.handleOperates.bind(this, '', 'batchDelete', true)}>批量删除</Button>
                    </div>
                    <div class="pull-right">
                        <Button type="primary" class="marigin-right-15" nativeOnClick={this.handleOperates.bind(this, '', 'exportQuery')}>查询条件导出</Button>
                    </div>
                </div>
            )
        },
        exportQuery() {
            let searchData = this.handleParams(this.formData);
            let requestData = {};
            // Object.keys(searchData).map(item => {
            //     requestData[`search[${item}]`] = searchData[item]
            // })
            // return console.log(searchData);
            this.handleWebfs(process.env.VUE_APP_APIURL_BI + "/api/v1/DemandForecast/exportByFilter", {
                ...searchData
            }, 'download').catch(err => {
                // this.$VMessage.error(err.message);
            })
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: 'supplierProductUpdate',
                        params: { type: "add" },
                        // query: { id: params },
                    });
                    break;
                case "query":
                    this.operate = {
                        title: '查看',
                        show: true,
                        width: 1200,
                        component: "compIndex",
                        activeid: params,
                        querytype: 'query',
                        showFooter: false
                    }
                    break;
                case "querySupplier":
                    this.operate = {
                        title: '查看',
                        show: true,
                        width: 1200,
                        component: "compIndex",
                        activeid: params,
                        querytype: 'query',
                        showFooter: false
                    }
                    break;
                case "edit":
                    // {
                    //     let url = this.$router.resolve({
                    //         name: "planForcastUpdate",
                    //         query: { id: params },
                    //         params: { type: 'edit' }
                    //     });
                    //     window.open(url.href, "__blank");
                    // }
                    this.operate = {
                        title: "编辑",
                        show: true,
                        width: 1200,
                        component: "compIndex",
                        activeid: params,
                        querytype: "edit",
                        showFooter: false
                    };
                    break;
                case "batchImport":
                    this.operate = {
                        show: true,
                        title: '批量导入',
                        width: 460,
                        showFooter: false,
                        component: "compBatchImport",
                    };
                    break;
                case "batchDelete":
                    this.operate = {
                        show: true,
                        alert: 'error',
                        title: '删除',
                        showDesc: true,
                        ajaxRequest: HttpDeleteForecast,
                        params: {
                            ids: params
                        },
                    }
                    break;
                case "exportQuery":
                    this.exportQuery();
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id } = row
            return [{
                label: '查看',
                show: true,
                params: id,
                operate: 'query'
            },
            {
                label: "编辑",
                show: true,
                params: id,
                operate: "edit"
            },
            {
                label: '删除',
                show: true,
                params: id,
                operate: 'batchDelete'
            }]
        },
    },
    computed: {
        ...mapGetters('diction', ['getNewProductList', 'getAllCurrency', 'getAllSupplier', 'getNewDifferentAllProductList']),
        productList() {
            return this.getNewDifferentAllProductList.map(item => {
                const bool = item.attach.flag === 3 ? 1 : 0
                return {
                    label: bool == 1 ? `<span class='color-error'>${item.label}(已关闭)</span>` : `${item.label}`,
                    value: item.value,
                }
            });
        },
        TabsData() {
            return [
                {
                    name: "所有",
                    key: 'queryEndDate',
                    val: 0,
                },
                {
                    name: "有效",
                    key: 'queryEndDate',
                    val: 1
                },
                {
                    name: "过期",
                    key: 'queryEndDate',
                    val: 2
                }
            ]
        },
        SearchsData() {
            let widthStyle = 'width: 250px'
            return [
                {
                    label: 'ERP SKU',
                    key: 'CN_erpsku',
                    show: true,
                    // tag: 'vInput',
                    tag: 'div',
                    removeInput: true,
                    children: (h) => {
                        return h('compErpSkuInput', {
                            props: {
                                value: this.formData.search.CN_erpsku,
                                showread: "showyes"
                            },
                            on: {
                                'on-data': (row) => {
                                    this.formData.search.CN_erpsku = row.erpSku;
                                },
                            }
                        })
                    }
                },
                {
                    label: "项目",
                    // labelWidth: 110,
                    tag: 'Select',
                    options: this.productList,
                    key: 'IN_lineId',
                    hideSearchTip: true,
                    props: {
                        multiple: true,
                        filterable: true,
                        clearable: true
                    },
                    show: true,
                    style: widthStyle,
                },
                {
                    label: 'Demand Class',
                    tag: 'Select',
                    key: 'IN_demandForecastClassId',
                    options: this.demandClassList,
                    style: widthStyle
                },
                {
                    label: 'Start Date',
                    tag: 'vDatepicker',
                    key: 'BT_startDate',
                    props: {
                        options: this.options,
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: widthStyle
                },
                {
                    label: 'End Date',
                    tag: 'vDatepicker',
                    key: 'BT_endDate',
                    props: {
                        options: this.options,
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: widthStyle
                },
                {
                    label: "创建时间",
                    tag: 'vDatepicker',
                    key: 'BT_createdAt',
                    props: {
                        options: this.options,
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: widthStyle
                },
                {
                    label: 'Update Time',
                    tag: 'vDatepicker',
                    key: 'BT_updatedAt',
                    props: {
                        options: this.options,
                        format: 'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm: false,
                    },
                    style: widthStyle
                }
            ]
        },
        columns() {
            return [
                {
                    show: false,
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                }, {
                    title: '操作',
                    width: 70,
                    render: this.getOperateNodes,
                }, {
                    title: 'ERP SKU',
                    width: 130,
                    render: (h, { row }) => {
                        return (
                            <div>
                                <a onClick={this.handleOperates.bind(this, row.id, 'querySupplier')}>{row.erpsku}</a>
                            </div>
                        )
                    }
                },
                {
                    title: '项目',
                    // width: 120,
                    render: (h, { row }) => {
                        let lineItem = this.getNewDifferentAllProductList.filter(item => {
                            return item.value === row.lineId
                        })[0];
                        return (
                            <div>{lineItem ? lineItem.label : '--'}</div>
                        )
                    }
                },
                {
                    title: 'Demand Class',
                    width: 120,
                    render: (h, { row }) => {
                        let demandItem = this.demandClassList.filter(item => {
                            return item.value === row.demandForecastClassId
                        })[0];
                        return (
                            <div>
                                {demandItem ? demandItem.label : '--'}
                            </div>
                        )

                    }
                },
                {
                    title: 'Time Bucket',
                    width: 100,
                    // key: 'timeBucket'
                    render: (h, { row }) => {
                        return <div>Week</div>
                    }
                },
                {
                    title: 'Number of Buckets',
                    // width: 240,
                    key: 'bucket'
                },
                {
                    title: 'Start Date',
                    key: 'startDate',
                    sortable: true
                },
                {
                    title: 'End Date',
                    key: 'endDate',
                    sortable: true
                },
                {
                    title: 'Start Week-End Week',
                    render: (h, { row }) => {
                        return <div>{`${row.startYear}-${row.startWeek}W ~ ${row.endYear}-${row.endWeek}W`}</div>
                    }
                },
                {
                    title: 'Qty/Bucket',
                    key: 'quantity'
                },
                {
                    title: 'Total Qty',
                    key: 'totalQuantity'
                },
                {
                    title: 'Update Time',
                    key: 'updatedAt',
                    width: 130
                }
            ];
        },

    }

};
